export const TEST_ID = 'navigationText';
